// The filter panel's styles, in one place.
//
// SaleReviewsPage and ListingSearchPage each carried their own copy of `inputStyle` and
// `labelStyle` — same values, two definitions, so the two filter bars drifted apart in
// padding and font size. Both now import from here.

export const inputStyle = {
  width: "100%",
  padding: "6px 8px",
  border: "1px solid #ced4da",
  borderRadius: "4px",
  fontSize: "13px",
  boxSizing: "border-box",
};

export const selectStyle = { ...inputStyle, backgroundColor: "#fff" };

export const labelStyle = {
  display: "block",
  fontSize: "12px",
  fontWeight: "600",
  marginBottom: "4px",
  color: "#495057",
};

export const hintStyle = {
  fontSize: "10px",
  color: "#8a94a0",
  marginTop: "3px",
  lineHeight: 1.3,
};

export const panelStyle = {
  padding: "16px",
  backgroundColor: "#fff",
  borderRadius: "8px",
  marginBottom: "16px",
  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
};

export const gridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(4, 1fr)",
  gap: "12px",
};

export const groupHeadingStyle = {
  gridColumn: "1 / -1",
  fontSize: "11px",
  fontWeight: 700,
  textTransform: "uppercase",
  letterSpacing: "0.04em",
  color: "#8a94a0",
  borderBottom: "1px solid #eef0f2",
  paddingBottom: "4px",
  marginTop: "4px",
};

export const primaryButton = (busy) => ({
  padding: "8px 18px",
  backgroundColor: "#000",
  color: "#fff",
  border: "none",
  borderRadius: "4px",
  fontSize: "14px",
  fontWeight: 500,
  cursor: busy ? "wait" : "pointer",
});

export const secondaryButton = {
  padding: "8px 14px",
  backgroundColor: "#6c757d",
  color: "#fff",
  border: "none",
  borderRadius: "4px",
  fontSize: "14px",
  fontWeight: 500,
  cursor: "pointer",
};

export const toggleButton = {
  padding: "7px 13px",
  background: "#fff",
  border: "1px solid #ced4da",
  borderRadius: "4px",
  fontSize: "13px",
  fontWeight: 500,
  color: "#333",
  cursor: "pointer",
};

export const countBadge = {
  marginLeft: "6px",
  fontSize: "11px",
  fontWeight: 700,
  color: "#1565c0",
  background: "#e3f2fd",
  borderRadius: "10px",
  padding: "1px 7px",
};

export const chipStyle = (on) => ({
  padding: "4px 10px",
  fontSize: "12px",
  fontWeight: 500,
  borderRadius: "14px",
  cursor: "pointer",
  userSelect: "none",
  border: `1px solid ${on ? "#1976d2" : "#ced4da"}`,
  background: on ? "#e3f2fd" : "#fff",
  color: on ? "#0d47a1" : "#495057",
});

export const activeChipStyle = {
  display: "inline-flex",
  alignItems: "center",
  gap: "5px",
  padding: "3px 8px",
  fontSize: "11px",
  fontWeight: 500,
  borderRadius: "12px",
  background: "#eef4fb",
  border: "1px solid #cfe0f3",
  color: "#28527a",
};
